exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-detail-cart-qty span {\n  margin: 0 20px; }\n  .product-detail-cart-qty span strong {\n    position: relative;\n    top: 4px;\n    padding-right: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/shared/components/product-detail/product-detail.component.scss
// module id = ../../../../../src/app/shared/components/product-detail/product-detail.component.scss
// module chunks = main